var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7368 6.62524V10.8252C16.7368 11.8053 16.7368 12.2954 16.5461 12.6697C16.3783 12.999 16.1106 13.2668 15.7813 13.4345C15.407 13.6252 14.9169 13.6252 13.9368 13.6252H3.78682C2.80673 13.6252 2.31668 13.6252 1.94233 13.4345C1.61305 13.2668 1.34533 12.999 1.17756 12.6697C0.986816 12.2954 0.986816 11.8053 0.986816 10.8252V4.17524C0.986816 3.19516 0.986816 2.7051 1.17756 2.33076C1.34533 2.00147 1.61305 1.73376 1.94233 1.56599C2.31668 1.37524 2.80673 1.37524 3.78682 1.37524H11.4868M16.7368 6.62524L11.4868 1.37524M16.7368 6.62524H12.8868C12.3967 6.62524 12.1517 6.62524 11.9646 6.52987C11.7999 6.44596 11.6661 6.31217 11.5822 6.14749C11.4868 5.96033 11.4868 5.71529 11.4868 5.22524V1.37524",
    stroke: "#A100FF",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a2a57cdbcfa8a2477eb454b8a446a0e0.svg";
export { ForwardRef as ReactComponent };